module.exports = __webpack_public_path__ + "img/0Q3B3739_WoodMatted.b6ae46c5.jpg";